<template>
  <div id="app">
    <HeaderPc />
    <HeaderM v-if="!($route.meta.showSelectHead && $route.meta.showSelectHead.mobile)" />
    <div class="jin-recruit-container">
      <router-view />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'App',
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'resumeList'
    ])
  },
  watch: {
    '$route.query.type': {
      async handler() {
        this.init()
        this.getDraft()
      },
      deep: true
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    ...mapActions('user', ['GET_USER']),
    ...mapActions('resume', ['GET_RESUMR_LIST', 'GET_DRAFT']),
    async init() {
      if (!(this.userInfo && this.userInfo.nick)) {
        this.GET_USER()
      }
      this.GET_RESUMR_LIST()
    },
    async getDraft() {
      const type = this.$route.query.type || 'online'
      await this.GET_DRAFT({ type })
    }
  }

}
</script>

<style lang="scss" scoped>
#app {
  height: 100vh;
  display: flex;
  flex-direction: column;

  .jin-recruit-container {
    // flex: 1;
    // overflow: auto;
  }
}
</style>
